import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorChaseLimitOrders = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M4.6 20.25c-.69 0-1.25-.56-1.25-1.25V5.105c0-.69.56-1.25 1.25-1.25h11.79c.69 0 1.25.56 1.25 1.25V15.58a.75.75 0 1 0 1.5 0V8.592H20c.69 0 1.25.56 1.25 1.25V19c0 .69-.56 1.25-1.25 1.25H4.6ZM19.14 7.092V5.105a2.75 2.75 0 0 0-2.75-2.75H4.6a2.75 2.75 0 0 0-2.75 2.75V19a2.75 2.75 0 0 0 2.75 2.75H20A2.75 2.75 0 0 0 22.75 19V9.842A2.75 2.75 0 0 0 20 7.092h-.86Z"
    />
    <path
      fill="#F7A600"
      d="M14.6 9.75a.75.75 0 0 0 0-1.5h-9a.75.75 0 1 0 0 1.5h9ZM14.6 13.15a.75.75 0 1 0 0-1.5h-2.4a.75.75 0 0 0 0 1.5h2.4ZM15.35 15.7a.75.75 0 0 1-.75.75h-2.4a.75.75 0 0 1 0-1.5h2.4a.75.75 0 0 1 .75.75ZM6.6 16.75h2A1.75 1.75 0 0 0 10.35 15v-2a1.75 1.75 0 0 0-1.75-1.75h-2A1.75 1.75 0 0 0 4.85 13v2c0 .967.783 1.75 1.75 1.75Zm2-1.5h-2a.25.25 0 0 1-.25-.25v-2a.25.25 0 0 1 .25-.25h2a.25.25 0 0 1 .25.25v2a.25.25 0 0 1-.25.25Z"
    />
  </svg>
);
export default SvgTwoColorChaseLimitOrders;
